"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportReviewRequestSchema = exports.ReportReviewBodySchema = exports.ReportReviewResourcesSchema = exports.REVIEW_PLATFORM_REPORT_REASON_LIST = exports.ReviewPlatformReportReason = exports.REVIEW_REPORT_REASON_LIST = exports.ReviewReportReason = exports.REVIEW_REPORT_TEXT_MAP = exports.ReviewReportType = void 0;
var zod_1 = require("zod");
// see-more-for-report request
exports.ReviewReportType = {
    /** 후기신고 */
    CONTENTS: 'CONTENTS',
    /** 계정 신고 */
    MEMBER: 'MEMBER',
    /** 계정 차단 */
    MEMBER_BLOCK: 'MEMBER_BLOCK',
};
exports.REVIEW_REPORT_TEXT_MAP = (_a = {},
    _a[exports.ReviewReportType.CONTENTS] = '후기 신고',
    _a[exports.ReviewReportType.MEMBER] = '계정 신고',
    _a[exports.ReviewReportType.MEMBER_BLOCK] = '계정 차단',
    _a);
/**
 * @deprecated ReviewPlatformReportReason 이용
 *
 * 관련 feature-flag:
 * - fe-api: reviewPlatform
 * - review-site: isCreateReviewWIP
 */
exports.ReviewReportReason = {
    CURSE: { code: 'CURSE', label: '욕설 또는 비속어를 포함한 게시물' },
    ADVERTISEMENT: { code: 'ADVERTISEMENT', label: '상업적인 홍보의 목적으로 작성된 게시물' },
    ANOTHER_PRODUCT: { code: 'ANOTHER_PRODUCT', label: '타업체가 언급된 게시물' },
    PERSONAL_INFORMATION: { code: 'PERSONAL_INFORMATION', label: '개인정보 포함 또는 유출 위험이 있는 게시물' },
    OBSCENITY: { code: 'OBSCENITY', label: '음란성 게시물 또는 청소년에게 부적합한 게시물' },
    SLANDEROUS: { code: 'SLANDEROUS', label: '회사 폄하 또는 비방 목적의 게시물' },
    ETC: { code: 'ETC', label: '기타' },
};
/**
 * @deprecated REVIEW_PLATFORM_REPORT_REASON_LIST 이용
 *
 * 관련 feature-flag:
 * - fe-api: reviewPlatform
 * - review-site: isCreateReviewWIP
 */
exports.REVIEW_REPORT_REASON_LIST = [
    exports.ReviewReportReason.CURSE,
    exports.ReviewReportReason.ADVERTISEMENT,
    exports.ReviewReportReason.ANOTHER_PRODUCT,
    exports.ReviewReportReason.PERSONAL_INFORMATION,
    exports.ReviewReportReason.OBSCENITY,
    exports.ReviewReportReason.SLANDEROUS,
    exports.ReviewReportReason.ETC,
];
// zod 로 ReviewReportRequest 만들기
/**
 * @deprecated ReportReviewRequestSchema 이용
 * 관련 feature-flag:
 * - fe-api: reviewPlatform
 * - review-site: isCreateReviewWIP
 */
var ReviewReportRequestSchema = zod_1.z.object({
    resources: zod_1.z.object({
        reviewId: zod_1.z.number(),
    }),
    body: zod_1.z.union([
        zod_1.z.object({
            reportType: zod_1.z.literal(exports.ReviewReportType.CONTENTS),
            reportReason: zod_1.z.union([
                zod_1.z.literal(exports.ReviewReportReason.CURSE.code),
                zod_1.z.literal(exports.ReviewReportReason.ADVERTISEMENT.code),
                zod_1.z.literal(exports.ReviewReportReason.ANOTHER_PRODUCT.code),
                zod_1.z.literal(exports.ReviewReportReason.PERSONAL_INFORMATION.code),
                zod_1.z.literal(exports.ReviewReportReason.OBSCENITY.code),
                zod_1.z.literal(exports.ReviewReportReason.SLANDEROUS.code),
                zod_1.z.literal(exports.ReviewReportReason.ETC.code),
            ]),
            contents: zod_1.z.string().min(5),
        }),
        zod_1.z.object({
            reportType: zod_1.z.union([zod_1.z.literal(exports.ReviewReportType.MEMBER), zod_1.z.literal(exports.ReviewReportType.MEMBER_BLOCK)]),
        }),
    ]),
});
exports.ReviewPlatformReportReason = {
    OFFENSIVE_LANGUAGE: { code: 'OFFENSIVE_LANGUAGE', label: '욕설 또는 비속어를 포함한 게시물' },
    COMMERCIAL_PROMOTION: { code: 'COMMERCIAL_PROMOTION', label: '상업적인 홍보의 목적으로 작성된 게시물' },
    COMPETITOR_MENTION: { code: 'COMPETITOR_MENTION', label: '타업체가 언급된 게시물' },
    PERSONAL_INFORMATION: { code: 'PERSONAL_INFORMATION', label: '개인정보 포함 또는 유출 위험이 있는 게시물' },
    OBSCENE_CONTENT: { code: 'OBSCENE_CONTENT', label: '음란성 게시물 또는 청소년에게 부적합한 게시물' },
    COMPANY_DEFAMATION: { code: 'COMPANY_DEFAMATION', label: '회사 폄하 또는 비방 목적의 게시물' },
    OTHER: { code: 'OTHER', label: '기타' },
};
exports.REVIEW_PLATFORM_REPORT_REASON_LIST = [
    exports.ReviewPlatformReportReason.OFFENSIVE_LANGUAGE,
    exports.ReviewPlatformReportReason.COMMERCIAL_PROMOTION,
    exports.ReviewPlatformReportReason.COMPETITOR_MENTION,
    exports.ReviewPlatformReportReason.PERSONAL_INFORMATION,
    exports.ReviewPlatformReportReason.OBSCENE_CONTENT,
    exports.ReviewPlatformReportReason.COMPANY_DEFAMATION,
    exports.ReviewPlatformReportReason.OTHER,
];
exports.ReportReviewResourcesSchema = zod_1.z.object({
    reviewId: zod_1.z.number(),
});
exports.ReportReviewBodySchema = zod_1.z.union([
    zod_1.z.object({
        reportType: zod_1.z.literal(exports.ReviewReportType.CONTENTS),
        reportReason: zod_1.z.union([
            zod_1.z.literal(exports.ReviewPlatformReportReason.OFFENSIVE_LANGUAGE.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.COMMERCIAL_PROMOTION.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.COMPETITOR_MENTION.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.PERSONAL_INFORMATION.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.OBSCENE_CONTENT.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.COMPANY_DEFAMATION.code),
            zod_1.z.literal(exports.ReviewPlatformReportReason.OTHER.code),
        ]),
        contents: zod_1.z.preprocess(function (val) {
            if (typeof val === 'string') {
                return val.replace(/\r?\n|\r/g, '\n').trim();
            }
            return val;
        }, zod_1.z.string().min(5).max(1000)),
    }),
    zod_1.z.object({
        reportType: zod_1.z.union([zod_1.z.literal(exports.ReviewReportType.MEMBER), zod_1.z.literal(exports.ReviewReportType.MEMBER_BLOCK)]),
    }),
]);
exports.ReportReviewRequestSchema = zod_1.z.object({
    resources: exports.ReportReviewResourcesSchema,
    body: exports.ReportReviewBodySchema,
});
